import FaceGood from '@/assets/img/IAReputation/face-good.svg'
import FaceRegular from '@/assets/img/IAReputation/face-regular.svg'
import FaceBad from '@/assets/img/IAReputation/face-bad.svg'

import LogoChatGpt from '@/assets/img/IAReputation/chatgpt.svg'
import LogoPerplexity from '@/assets/img/IAReputation/perplexity.svg'
import LogoClaude from '@/assets/img/IAReputation/claude.svg'
import LogoGemini from '@/assets/img/IAReputation/gemini.svg'
import LogoDeepseek from '@/assets/img/IAReputation/deepseek.svg'
import LogoGrok from '@/assets/img/IAReputation/grok.svg'
import LogoMistral from '@/assets/img/IAReputation/mistral.svg'

import LogoChatGptIco from '@/assets/img/IAReputation/chatgpt-ico.svg'
import LogoPerplexityIco from '@/assets/img/IAReputation/perplexity-ico.svg'
import LogoClaudeIco from '@/assets/img/IAReputation/claude-ico.svg'
import LogoGeminiIco from '@/assets/img/IAReputation/gemini-ico.svg'
import LogoDeepseekIco from '@/assets/img/IAReputation/deepseek-ico.svg'
import LogoGrokIco from '@/assets/img/IAReputation/grok-ico.svg'
import LogoMistralIco from '@/assets/img/IAReputation/mistral-ico.svg'
import IcoCheck from "@/assets/img/IAReputation/check.svg";
import IcoNoCheck from "@/assets/img/IAReputation/xcircle.svg";
export default {
  data() {
    return {
      llms: ['openai', 'perplexity', 'anthropic', 'google',/* 'xai','mistral'*/],
      idNodeHealthyPoke: 13,
      idNodePansCompany: 311,
      idNodeRibs: 318,
      idNodeIlCortile: 33,
      idNodeCanPizza: 68
    }
  },
  computed: {
    dimensions () {
      if (!this.data) return []
      return Array.from(new Set(this.data.reputation_index['openai'].prompts_answers.direct.filter(e => e.type !== 'generic').map(e => e.dimension))).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))
    },
    brandUUID () {
      // si api tiene healthypoke y el nodo de la marca es tal si tienen
      if (this.$config.api.indexOf('healthypoke') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeHealthyPoke) {
        return 'b5711f43-1bc3-48ba-96d5-ce32ad8a1038'
      }
      //IBERSOL PANS COMPANY
      if (this.$config.api.indexOf('ibersol') > -1 && parseInt(this.$store.getters.getNode) === this.idNodePansCompany) {
        return 'ecc0c7df-bcb5-4567-b5d1-4d50a3f26ede'
      }
      //RIBS
      if (this.$config.api.indexOf('ibersol') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeRibs) {
        return '280f5977-8023-41f8-9e50-dcfe20034925'
      }
      //IL CORTILE
      if (this.$config.api.indexOf('gastroagencia') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeIlCortile) {
        return 'd9024df3-bacc-42d9-baf5-5b507c1d8475'
      }
      //CAN PIZZA
      if (this.$config.api.indexOf('cex') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeCanPizza) {
        return '5fbc7335-0278-4793-b57b-71beb60fe53b'
      }
      return ''
    },
    hasIAInNode () {
      return [this.idNodeHealthyPoke, this.idNodePansCompany, this.idNodeRibs, this.idNodeIlCortile].includes(parseInt(this.$store.getters.getNode))
    },
    brandName () {
      if (document.querySelector('.tree-active')) { return document.querySelector('.tree-active').getAttribute('data-name')}
      return ''
    }
  },
  methods: {
    getScoreGlobalByQuestionDirectByLLM(text) {
      let count = 0
      let sum = 0
      const llmsExist = Object.keys(this.data.reputation_index)

      llmsExist.forEach((llm) => {
        sum += this.data.reputation_index[llm].prompts_answers.direct.filter(e => e.text === text)[0].metrics_analysis.sentiment.score || 0
        count++
      })
      return sum / count
    },
    getScoreGlobalByQuestionIndirectByLLM(text) {
      let count = 0
      let sum = 0
      const llmsExist = Object.keys(this.data.reputation_index)
      console.log(this.data, text)
      llmsExist.forEach((llm) => {
          if (this.data.reputation_index[llm].prompts_answers.indirect.filter(e => e.text === text).length > 0) {
            sum += this.data.reputation_index[llm].prompts_answers.indirect.filter(e => e.text === text)[0].metrics_analysis.sentiment.score || 0
            count++
          }
      })
      return sum / count
    },
    getScoreByQuestionDirectByLLM(llm, text) {
      if (!this.data || !this.data.reputation_index[llm]) return []
      if (this.data.reputation_index[llm].prompts_answers.direct.filter(e => e.text === text).length > 0) {
        return this.data.reputation_index[llm].prompts_answers.direct.filter(e => e.text === text)[0].metrics_analysis.sentiment.score || 0
      }
      return 0
    },
    getScoreByQuestionIndirectByLLM(llm, text) {
      if (!this.data || !this.data.reputation_index[llm]) return []
      return this.data.reputation_index[llm].prompts_answers.indirect.filter(e => e.text === text)[0].metrics_analysis.sentiment.score || 0
    },
    verifyIndirectPromptsVisibility (text, llm) {
      if (Object.keys(this.data.reputation_index).includes(llm) && this.data.reputation_index[llm].prompts_answers.indirect.some(e => e.text === text) && this.data.reputation_index[llm].prompts_answers.indirect.filter(e => e.text === text)[0].metrics_analysis.visibility.visibility) {
        return IcoCheck
      }
      return IcoNoCheck
    },
    getNotExistLLM(data, llm) {
      if (!data) { return false }
      return !Object.keys(data.reputation_index).includes(llm.toLowerCase())
    },
    getColorByPercent(percent) {
      if (percent >= 0 && percent < 50) { return '#F63527' }
      if (percent >= 50 && percent < 80) { return '#FF9800' }
      if (percent >= 80 && percent <= 100) { return '#8AC543' }
    },
    getColorByScore(score) {
      if (score < -0.25) { return '#F63527' }
      if (score >= -0.25 && score < 0.25) { return '#FF9800' }
      if (score >= 0.25) { return '#8AC543' }
    },
    getColorByAttributesScore(score) {
      if (score < 50) { return '#F63527' }
      if (score >= 50 && score < 75) { return '#FF9800' }
      if (score >= 75) { return '#8AC543' }
      /*De 50 para abajo rojo. De 50 a 75 naranja y por encima verde*/
    },
    getColorByLLM(llm) {
      if (llm === 'openai') { return '#6F6C7B' }
      if (llm === 'perplexity') { return '#21B8CD' }
      if (llm === 'claude') { return '#D97757' }
      if (llm === 'google') { return '#6478F5' }
      if (llm === 'deepseek') { return '#4FCDFC' }
      if (llm === 'xai') { return '#222226' }
    },
    getImageByPercentLLM(percent) {
      if (percent >= 80) {
        return FaceGood
      }
      if (percent >= 50 && percent < 80) {
        return FaceRegular
      }
      if (percent >= 0 && percent < 50) {
        return FaceBad
      }
    },
    getImageByScoreLLM(score) {
      if (score < -0.25) {
        return FaceBad
      }
      if (score >= -0.25 && score < 0.25) {
        return FaceRegular
      }
      if (score >= 0.25) {
        return FaceGood
      }
    },
    getLogoByLLM(llm, isIco = false) {
      if (llm === 'openai' && !isIco) { return LogoChatGpt }
      if (llm === 'perplexity' && !isIco) { return LogoPerplexity }
      if (llm === 'anthropic' && !isIco) { return LogoClaude }
      if (llm === 'google' && !isIco) { return LogoGemini }
      if (llm === 'deepseek' && !isIco) { return LogoDeepseek }
      if (llm === 'xai' && !isIco) { return LogoGrok }
      if (llm === 'mistral' && !isIco) { return LogoMistral }
      if (llm === 'openai' && isIco) { return LogoChatGptIco }
      if (llm === 'perplexity' && isIco) { return LogoPerplexityIco }
      if (llm === 'anthropic' && isIco) { return LogoClaudeIco }
      if (llm === 'google' && isIco) { return LogoGeminiIco }
      if (llm === 'deepseek' && isIco) { return LogoDeepseekIco }
      if (llm === 'xai' && isIco) { return LogoGrokIco }
      if (llm === 'mistral' && isIco) { return LogoMistralIco }
    }
  }
}
